// Public livestream viewer — entry module for the /live route.
//
// Wrapper + lazy + shell pattern (mirrors client/src/pages/CampaignPhotoPage.tsx
// / client/src/pages/patient-portal/sign_envelope.tsx): this file is
// module-level and import-cheap so index.tsx can eager-import
// LiveStreamLoadingShell (for both the explicit route and the
// PublicCatchAllDispatcher intercept) without dragging the heavy content
// chunk — Relay polling, the join flow, and the amazon-ivs-player video
// chunk — along with it. LiveStreamApp (and its own further-nested lazy
// LiveVideoPlayer) render only inside the <Suspense> below.
// See docs/infrastructure/PATIENT_FACING_EMAIL_LINKS.md and
// docs/livestreaming/plan.md § "2026-07-21 — Web-first V1 pivot".
import { lazy, Suspense } from "react";
import { Spin } from "antd";

const LiveStreamApp = lazy(() => import("../components/livestream/LiveStreamApp"));

// Full-viewport loader so a viewer never sees a flash of the quote-funnel
// landing page while the /live chunk downloads. Exported so the /* catch-all
// dispatcher in index.tsx can reuse the same loading state when it
// intercepts /live at the splat level.
export const LiveStreamLoadingShell = () => (
  <div
    style={{
      minHeight: "100vh",
      backgroundColor: "#f5f5f5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column",
      gap: 16,
    }}
  >
    <Spin size="large" />
    <div style={{ color: "#666", fontSize: 14 }}>Loading the livestream…</div>
  </div>
);

const LiveStreamPage: React.FC = () => (
  <Suspense fallback={<LiveStreamLoadingShell />}>
    <LiveStreamApp />
  </Suspense>
);

export default LiveStreamPage;
